import {
	BaseError,
} from './BaseError';

export class GetSpecificationError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
